import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import styled from "@emotion/styled";
import { CardMedia } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const MotionBox = motion(Box);

const TitleCards = styled.p`
  font-family: "Oswald", serif;
  font-size: 20px;
  color: black;
  display: inline-block;
  font-weight: 400;
  text-align: center;
`;

const Carrusel = ({ cards, LinkTo }) => {
  const [startIndex, setStartIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:900px)");
  const isLaptopOrLarger = useMediaQuery("(min-width:1024px)");

  const cardsToShow = isMobile ? 1 : isTablet ? 2 : 3;
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (LinkTo === "Facebook") {
      window.open("https://www.facebook.com/CONACCRM", "_blank");
    } else {
      navigate("/Nosotros");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const nextCards = () => {
    if (startIndex + cardsToShow < cards.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prevCards = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <MotionBox
      sx={{ textAlign: "center", mt: 4 }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          overflow: "hidden",
          width: "90%",
          margin: "0 auto",
          flexWrap: "nowrap",
          height: "100%",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Button
          onClick={prevCards}
          variant="contained"
          disabled={startIndex === 0}
          sx={{
            backgroundColor: "#12b854",
            color: "white",
            borderRadius: "10px",
            "&:hover": { color: "white", backgroundColor: "#0d6834" },
            padding: isMobile ? "10px 20px" : "150px 20px",
            width: isMobile ? "100%" : "auto",
          }}
        >
          <FaArrowLeft color="black" />
        </Button>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            overflowX: "auto",
            justifyContent: "center",
          }}
        >
          {cards.slice(startIndex, startIndex + cardsToShow).map((card, index) => (
            <Card
              key={index}
              sx={{
                width: isMobile ? 250 : 280,
                textAlign: "center",
                boxShadow: 3,
                "&:hover": { cursor: "pointer" },
              }}
              onClick={handleCardClick}
            >
              <CardMedia
                component="img"
                height={isMobile ? "180" : "250"}
                image={card.image}
                alt={card.title}
              />
              <CardContent>
                <TitleCards style={{ fontSize: isMobile ? "18px" : "20px" }}>
                  {card.title}
                </TitleCards>
                {!isMobile && (
                  <Typography variant="body2">{card.content}</Typography>
                )}
              </CardContent>
            </Card>
          ))}
        </Box>

        <Button
          onClick={nextCards}
          variant="contained"
          disabled={startIndex + cardsToShow >= cards.length}
          sx={{
            backgroundColor: "#12b854",
            color: "white",
            borderRadius: "10px",
            "&:hover": { color: "white", backgroundColor: "#0d6834" },
            padding: isMobile ? "10px 20px" : "150px 20px",
            width: isMobile ? "100%" : "auto",
          }}
        >
          <FaArrowRight color="black" />
        </Button>
      </Box>
    </MotionBox>
  );
};

export default Carrusel;
